document.addEventListener('DOMContentLoaded', function () {
  const bypassKey = 'moments'; 
  const urlParams = new URLSearchParams(window.location.search);
  const bypassFromURL = urlParams.get(bypassKey);

  if (bypassFromURL === 'true') {
    localStorage.setItem('susy_bypass', 'true');
  }

  if (bypassFromURL === 'false') {
    localStorage.removeItem('susy_bypass');
  }

  const isBypass = localStorage.getItem('susy_bypass') === 'true';

  if (!isBypass) {
    document.body.classList.add('nocopy');
    document.querySelectorAll('img').forEach(img => {
      img.classList.add('nocopy');
    });

    document.addEventListener('contextmenu', event => event.preventDefault());
    document.addEventListener('dragstart', event => event.preventDefault());
    document.addEventListener('selectstart', event => event.preventDefault());

    document.onkeydown = function(e) {
      const key = e.key.toLowerCase();
      const isCtrlOrCmd = e.ctrlKey || e.metaKey;

      if (isCtrlOrCmd && ['c', 'x', 'a', 's', 'u', 'p'].includes(key)) {
        e.preventDefault();
      }

      if (
        e.key === 'F12' || 
        (isCtrlOrCmd && e.shiftKey && ['i', 'c', 'j'].includes(key))
      ) {
        e.preventDefault();
      }
    };
  }
});